getdata()<template src="./index.html"></template>
<script>
import {getdata} from './data.js';
export default {
	data() {
		return {
			//表格筛选
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('../components/page/MasterDataInformation/AdditionalInformation/SceneTemplate')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('../components/page/MasterDataInformation/AdditionalInformation/SceneTemplate')) || [],
			//表格搜索
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			//表格
			tableHeight: null,
			tableData: [],
			pagination: getdata().pagination,
			tablekey: 0,
			additional: [],
			value: [],
			tempName: '',
			modification: false,
			newly: false,
			uapdeteandata:{},
			//排序字段名称
			order: '',
			//排序顺序
			sort: ''
			
		};
	},
	created() {},
	mounted() {
		this.selectcjmb();
	},
	methods: {
		//排序
		sortchange(e) {
			console.log(e);
			this.order = e.prop;
			if (e.order == 'ascending') {
				this.sort = 'ASC';
			} else if (e.order == 'descending') {
				this.sort = 'DESC';
			} else {
				this.sort = '';
			}
			this.selectcjmb();
		},
		
		deletecjmb() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			}
			let params = this.$refs.tablebox
				.getSelectionval()
				.map(v => v.id)
				.join(',');
			this.$https.fetchPost('felec/addInformMaintain/deleteScenarioTemplate', params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectcjmb();
				} else {
					this.$message.error('失败');
				}
			});
		},
		selectcjmb() {
			let patea = {
				limit: this.pagination.pageSize,
				page: this.pagination.pageNum,
				order: this.order,
				sort: this.sort,
				param: JSON.parse(JSON.stringify(this.searchdata))
			};
			this.$https.fetchPost('felec/addInformMaintain/getScenarioTemplateList', patea).then(res => {
				if (res.data.code == '200') {
					this.pagination.total = res.data.count;
					this.tableData = res.data.data.map(v => {
						if (v.chuangjsj != null) {
							if (v.chuangjsj.length == 8) {
								var reg = /^(\d{4})(\d{2})(\d{2})$/;
								v.chuangjsj = v.chuangjsj.replace(reg, '$1年$2月$3日');
							} else if (v.chuangjsj.length == 14) {
								var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
								v.chuangjsj = v.chuangjsj.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
							}
							if (v.xiugsj.length == 8) {
								var reg = /^(\d{4})(\d{2})(\d{2})$/;
								v.xiugsj = v.xiugsj.replace(reg, '$1年$2月$3日');
							} else if (v.xiugsj.length == 14) {
								var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
								v.xiugsj = v.xiugsj.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
							}
						}
						return v;
					});
				} else {
					this.$message.error('失败');
				}
			});
		},
		// 		selectnsfe() {
		// 			 this.additional= this.additional1.filter((p)=>{
		//               return p.label.indexOf(this.tempName) !==-1
		//             })
		// 		},
		Addqr() {
			if (!this.tempName) {
				this.$message.error('异常提示: 场景模板名称不能为空');
				return;
			}
			if (this.value.length < 1) {
				this.$message.error('异常提示: 请选择附加信息');
				return;
			}
			let patea = {
				changjmbmc: this.tempName,
				guanlfjxx: this.value.join(',')
			};
			this.$https.fetchPost('felec/addInformMaintain/addScenarioTemplate', patea).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.newly = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectcjmb();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		Addtk() {
		this.uapdeteandata=[];
		this.additional = [];
		this.value=[];
			this.$https.fetchPost('felec/addInformMaintain/getAddInformItemByCode').then(res => {
				if (res.data.code == '200') {
					res.data.data.sort(function(a, b) {
						return a.xuh - b.xuh;
					});
					for (var i = 0; i < res.data.data.length; i++) {
						this.additional.push({
							key: res.data.data[i].id,
							label: res.data.data[i].fujxxmc
						});
					}
					this.newly = true;
				}
			});
		},
		uapudet(v){
			this.uapdeteandata=v;
			this.additional = [];
			this.value=[];
			this.$https.fetchPost('felec/addInformMaintain/getAddInformItemByCode').then(res => {
				if (res.data.code == '200') {
					res.data.data.sort(function(a, b) {
						return a.xuh - b.xuh;
					});
					for (var i = 0; i < res.data.data.length; i++) {
						this.additional.push({
							key: res.data.data[i].id,
							label: res.data.data[i].fujxxmc
						});
					}
					this.tempName=v.changjmbmc
					for (let i=0;i<v.guanlfjxx.split(',').length;i++) {
						for (let j=0;j<this.additional.length;j++) {
							if(v.guanlfjxx.split(',')[i]==this.additional[j].label){
								this.value.push(this.additional[j].key)
							}
						}
					}
					this.modification=true;
				}
			});
		},
		uapdetean(){
			if (!this.tempName) {
				this.$message.error('异常提示: 场景模板名称不能为空');
				return;
			}
			if (this.value.length < 1) {
				this.$message.error('异常提示: 请选择附加信息');
				return;
			}
			let patea = {
				changjmbmc: this.tempName,
				guanlfjxx: this.value.join(','),
				id:this.uapdeteandata.id
			};
			this.$https.fetchPost('felec/addInformMaintain/updateScenarioTemplate',patea).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.modification = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectcjmb();
				} else {
					this.$message.error(res.data.message);
				}
			})
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('../components/page/MasterDataInformation/AdditionalInformation/SceneTemplate', JSON.stringify(e.nochooselist));
			localStorage.setItem('../components/page/MasterDataInformation/AdditionalInformation/SceneTemplate', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		//表格搜索
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.selectcjmb();
		},
		//表格分页
		sizechange(e) {
			this.pagination.pageSize = e;
			this.selectcjmb();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.selectcjmb();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
